<template>
  <div class="p-4">
    <h1>Notificaciones Push de Escritorio</h1>
    <button @click="solicitarPermiso">Solicitar permiso</button>
    <button @click="enviarNotificacion">Enviar notificación</button>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const permiso = ref(Notification.permission);

const solicitarPermiso = async () => {
  if (!("Notification" in window)) {
    alert("Este navegador no soporta notificaciones.");
    return;
  }

  const resultado = await Notification.requestPermission();
  permiso.value = resultado;

  if (resultado === "granted") {
    alert("Permiso concedido para notificaciones.");
  } else {
    alert("Permiso denegado.");
  }
};

const enviarNotificacion = () => {
  if (permiso.value !== "granted") {
    alert("Primero debes conceder permiso para notificaciones.");
    return;
  }

  const notificacion = new Notification("¡Hola desde Vue!", {
    body: "Esta es una notificación push de escritorio.",
    icon: "https://cdn-icons-png.flaticon.com/512/753/753318.png" // opcional
  });

  notificacion.onclick = () => {
    window.focus();
    notificacion.close();
  };
};
</script>

<style>
button {
  margin: 5px;
  padding: 10px;
  font-size: 1rem;
}
</style>